import { takeLatest, put } from 'redux-saga/effects'

import { createReducer, makeAction, makeKeys } from './helper'
import { httpGet } from 'core/restClient'
import { appLoading, appLoaded } from './app'
import r from 'reactotron-react-js'

const FETCH_WORKLIST = makeKeys('FETCH_WORKLIST')

export const fetchWorkList = makeAction(FETCH_WORKLIST.REQUEST, 'data')

const fetchWorkListSuccess = makeAction(FETCH_WORKLIST.SUCCESS, 'data')

const initial = {
  workLists: { summary: [], worklistItem: [] },
}

function* fetchWorkListRequest(action) {
  const { data } = action.payload
  try {
    yield put(appLoading())
    let xx = `${new Date(data == null ? Date.now() : data.date[0]).toJSON()},${new Date(data == null ? Date.now() : data.date[1]).toJSON()}`
    if(data){
      if(data.poStatus!='-'){
        data.activityName = data.poStatus
      }
    }
    const workList = yield httpGet('share/workflow/getWorklist', { ...data, dateRange: xx })
    if (workList.status === 200) {
      yield put(fetchWorkListSuccess(workList.data))
    }
    yield put(appLoaded())
  } catch (e) {
    // Add process reload work list data on case token is missing
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(fetchWorkList())
    }

    yield put(appLoaded())
  }
}

export function* watchWorkListSaga() {
  yield takeLatest(FETCH_WORKLIST.REQUEST, fetchWorkListRequest)
}

export default createReducer(initial, state => ({
  [FETCH_WORKLIST.REQUEST]: () => ({
    ...state,
    loading: true
  }),
  [FETCH_WORKLIST.SUCCESS]: (data) => ({
    ...state,
    loading: false,
    workLists: data.data
  }),

}))
